module.exports = __webpack_public_path__ + "static/logo-48f061c6d14ce8f13061dc28eb28d0fd.png";